import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';

interface StatsRowProps {
  postsCount: number;
  propertiesCount: number;
}

function Stat({
  value,
  label,
  color,
  mutedColor,
}: {
  value: number;
  label: string;
  color: string;
  mutedColor: string;
}) {
  return (
    <View style={styles.stat}>
      <Text style={[styles.value, { color }]}>{value}</Text>
      <Text style={[styles.label, { color: mutedColor }]}>{label}</Text>
    </View>
  );
}

export function StatsRow({ postsCount, propertiesCount }: StatsRowProps) {
  const { colors } = useTheme();

  return (
    <View
      style={styles.statsRow}
      // @ts-expect-error dataSet is a react-native-web prop (visual-audit CSS masking hook); not in RN's type defs
      // 'wide': counts are live data (audit runs create/delete posts as the
      // audit user mid-gate) and digit-count changes the row's box width.
      dataSet={{ visualmask: 'wide' }}>
      <Stat
        value={postsCount}
        label="Posts"
        color={colors.text}
        mutedColor={colors.textSecondary}
      />
      <View style={[styles.divider, { backgroundColor: colors.border }]} />
      <Stat
        value={propertiesCount}
        label="Properties"
        color={colors.text}
        mutedColor={colors.textSecondary}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  statsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACING.lg,
    marginBottom: SPACING.lg,
  },
  stat: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: SPACING.xs,
  },
  value: {
    ...TYPOGRAPHY.button,
  },
  label: {
    ...TYPOGRAPHY.bodySmall,
  },
  divider: {
    width: StyleSheet.hairlineWidth,
    alignSelf: 'stretch',
    marginVertical: SPACING.xxs,
  },
});
